import { type RouteObject } from 'react-router'

import { RECOMMENDATIONS_URL } from 'features/recommendations/paths'
import { lazyDefault } from 'routes/lazy-route'

export const recommendationsRoutes: RouteObject[] = [
  {
    path: RECOMMENDATIONS_URL,
    lazy: lazyDefault(() => import('features/recommendations/Container')),
    handle: { featureKey: RECOMMENDATIONS_URL },
  },
]
